import * as jsxRuntime from "D:\\VSTSProjects\\ERP-AuthorityPayrollPortal\\AuthorityPayrollPortal\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment